import { render } from "./DynamicHtmlA.vue?vue&type=template&id=4a44a94f&ts=true"
import script from "./DynamicHtmlA.vue?vue&type=script&lang=ts"
export * from "./DynamicHtmlA.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicHtmlA.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a44a94f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a44a94f', __exports__)) {
    api.reload('4a44a94f', __exports__)
  }
  
  module.hot.accept("./DynamicHtmlA.vue?vue&type=template&id=4a44a94f&ts=true", () => {
    api.rerender('4a44a94f', render)
  })

}


export default __exports__